module.exports = __webpack_public_path__ + "img/us-co.b25c2286.svg";